import React from 'react';
import DeviceInfoDialog from '../dialogs/deviceInfoDialog';
import DeviceLogsDialog from '../dialogs/deviceLogsDialog';
import RegisterDialog from '../dialogs/registerDialog';
import DonwloadDialog from '../dialogs/download/downloadDialog';
import DownloadLogsDialog from '../dialogs/download/historyDialog';
import { Panels, PanelsType } from '../../modules/dialogs/model';
import DeviceReadRightDialog from '../dialogs/readRightEditDialog';
import TxDialog from '../dialogs/transfer/txDialog';
import HelloWorldDialog from '../dialogs/HelloWorldDialog';
import useRightPanel from '../../hooks/useRightPanel';
import { DialogBox } from './dialog/context';
import TxDialogDevices from '../dialogs/transfer/txDialogDevices';

interface OwnProps {
  activeDialog: PanelsType;
}

type Props = OwnProps;

const DialogSelector: React.FC<Props> = (props) => {
  const { setDialog } = useRightPanel();
  let id = 'no-panel';
  let selectedDialog = undefined;
  const panelId = props.activeDialog as Panels;
  if (panelId) {
    switch (panelId) {
      case Panels.DEVICE_DETAILS:
        id = 'device-details-dialog';
        selectedDialog = <DeviceInfoDialog />;
        break;
      case Panels.DEVICE_LOGS:
        id = 'device-logs-dialog';
        selectedDialog = <DeviceLogsDialog />;
        break;
      case Panels.DEVICE_REGISTER:
        id = 'register-dialog';
        selectedDialog = <RegisterDialog />;
        break;
      case Panels.DEVICE_DOWNLOAD:
        id = 'download-dialog';
        selectedDialog = <DonwloadDialog />;
        break;
      case Panels.DEVICE_DOWNLOAD_LOGS:
        id = 'download-logs-dialog';
        selectedDialog = <DownloadLogsDialog />;
        break;
      case Panels.DEVICE_READRIGHTS:
        id = 'readrights-dialog';
        selectedDialog = <DeviceReadRightDialog />;
        break;
      case Panels.DEVICE_TRANSFER:
        id = 'transfer-dialog';
        selectedDialog = <TxDialog />;
        break;
      case Panels.HELLO_WORLD:
        id = 'helloworld-dialog';
        selectedDialog = <HelloWorldDialog />;
        break;
      case Panels.TRANSFER_DEVICES:
        id = 'transferDevices-dialog';
        selectedDialog = <TxDialogDevices />;
        break;
      default:
        break;
    }
  }

  return selectedDialog ? (
    <div id={id} className={`panel ${id}`}>
      <DialogBox value={{ dialogId: panelId, setDialog }}>
        {selectedDialog}
      </DialogBox>
    </div>
  ) : (
    <></>
  );
};

export default DialogSelector;
